import { Block } from 'baseui/block';
import { memo } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { NOTIFICATION_EVIDENCE_DETAIL_PAGE } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { NotificationEvidence } from '../../types/notification';
import { NotificationOrigin } from '../../types/notificationConfig';
import MediaThumbnail from '../shared/MediaThumbnail';

type Props = {
  notificationId: string;
  origin: NotificationOrigin;
  media: NotificationEvidence;
};

function NotificationEvidenceMediaItem({ notificationId, media, origin }: Readonly<Props>) {
  const { theme, css } = useStyles();
  const { id: workspaceId } = useParams();
  const navigate = useNavigate();
  const styles = css({
    borderRadius: theme.borders.popoverBorderRadius,
    height: 'auto',
    width: '100%',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    ':hover': {
      background: theme.colors.buttonTertiaryHover,
    },
  });

  const onSelectMedia = () => {
    void navigate(
      generatePath(NOTIFICATION_EVIDENCE_DETAIL_PAGE.route, { id: workspaceId, notificationId, evidenceId: media.id }),
    );
  };

  return (
    <Block
      className={styles}
      onClick={onSelectMedia}
    >
      <MediaThumbnail
        mediaKey={media.key}
        origin={origin}
      />
    </Block>
  );
}

export default memo(NotificationEvidenceMediaItem);
